import { G } from '@mobily/ts-belt';
import { FieldProps, useRecordContext } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { SelectChipField } from '@sh4res/bo-common/fields';

export function InstrumentRiskField(props: FieldProps & { 'data-testid'?: string }) {
  const record = useRecordContext<GetInstrumentOneResponse>();

  if (!record) {
    return null;
  }

  return (
    <SelectChipField
      {...props}
      source="risk"
      record={{ risk: G.isNotNullable(record.risk) ? `${record.risk}/7` : null }}
      displayRawValueIfChoiceNotFound
      data-testid={props['data-testid']}
    />
  );
}
